// @flow
import * as types from "../ACTIONS/commonActionTypes";
import initialState from './commonInitialState';

export default function deviceStatusReducer(state = initialState.device, ourClientId:number, action) {

    switch (action.type) {

        case types.SET_DEVICE_STATUS: {
            const newState = {...state};
            newState.status = action.status;
            return newState;
        }
        case types.SET_DEVICE_MODE: {
            const newState = {...state};
            newState.mode = action.mode;
            return newState;
        }
        case types.SET_DEVICE_STATUS_AND_MODE: {
            const newState = {...state};
            newState.status = action.status;
            newState.mode = action.mode;
            return newState;
        }
        default:
            return state;
    }
}
